/**
 * @param {import("@/types").User} user
 * @param {import("@/types").Customer} customer
 * @returns boolean
 */
function privateIsAdmin(user, customer) {
  return (
    !customer.isRoot &&
    (user.wavelengthEmployee || user.organizationSettings?.isAdmin?.[customer.id])
  )
}

/**
 * @param {boolean} showAdminView
 * @param {import("@/types").User} user
 * @param {import("@/types").Customer} customer
 * @returns boolean
 */
export default function isAdmin(user, customer, showAdminView) {
  return showAdminView && privateIsAdmin(user, customer)
}
